export const ClosedMaxHeight = '0px';
export const getDefaultMaxHeight = (expanded) => {
    return expanded ? undefined : ClosedMaxHeight;
};
export const getNextMaxHeight = (expanded, maxHeight, contentWrapper) => {
    return expanded || !maxHeight ? `${contentWrapper.scrollHeight}px` : ClosedMaxHeight;
};
export const focusContentWrapper = (expanded, focusOnExpanded, contentWrapper) => {
    if (expanded && focusOnExpanded) {
        contentWrapper.focus();
    }
};
export const prepareAnimateToExpanded = (expanded, maxHeight, contentWrapper, setMaxHeight) => {
    if (maxHeight === `${contentWrapper.scrollHeight}px` && !expanded) {
        requestAnimationFrame(() => {
            setMaxHeight(ClosedMaxHeight);
        });
    }
};
export const handleTransitionEnd = (expanded, focusOnExpanded, contentWrapper, e, setMaxHeight, callback) => {
    if (e.target !== contentWrapper ||
        (e.target === contentWrapper && e.propertyName !== 'max-height')) {
        return;
    }
    focusContentWrapper(expanded, focusOnExpanded, contentWrapper);
    if (expanded) {
        setMaxHeight(undefined);
    }
    if (callback) {
        callback(e, expanded);
    }
};
export const getTabIndex = (expanded, focusOnExpanded) => {
    return expanded && focusOnExpanded ? '0' : null;
};
